import TranslatedEnum from './TranslatedEnum.js'

export default class VerarbeitungStatusEnum extends TranslatedEnum {
  static get KEYS() {
    return {
      IN_QUEUE: 'IN_QUEUE',
      VALIDATING: 'VALIDATING',
      COMPLETED_SUCCESS: 'COMPLETED_SUCCESS',
      COMPLETED_FAILED: 'COMPLETED_FAILED',
      CANCELLED: 'CANCELLED'
    }
  }

  static get I18N() {
    return {
      de: {
        IN_QUEUE: 'In Queue',
        VALIDATING: 'Wird verarbeitet',
        COMPLETED_SUCCESS: 'Verarbeitet (keine Fehler)',
        COMPLETED_FAILED: 'Verarbeitet (mit Fehler)',
        CANCELLED: 'Storniert'
      },
      fr: {
        IN_QUEUE: 'En attente',
        VALIDATING: 'En cours de traitement',
        COMPLETED_SUCCESS: 'Traité (sans erreur)',
        COMPLETED_FAILED: 'Traité (avec erreur)',
        CANCELLED: 'Annulé'
      },
      it: {
        IN_QUEUE: 'In coda',
        VALIDATING: 'In elaborazione',
        COMPLETED_SUCCESS: 'Elaborata (senza errori)',
        COMPLETED_FAILED: 'Elaborata (con errori)',
        CANCELLED: 'Stornata'
      }
    }
  }
}
